import React from 'react';

/**
 * Formes d'attente. Elles reprennent la silhouette de ce qui va s'afficher :
 * l'œil se place avant que la donnée arrive, et la page ne saute pas au moment
 * du remplissage — ce que ne permet pas un disque qui tourne au centre.
 *
 * `aria-hidden` : rien à annoncer ici, le conteneur porte déjà `aria-busy`.
 */

export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="card" aria-hidden="true">
      <div className="skeleton sk-title" />
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className={`skeleton sk-line ${i === lines - 1 ? 'sk-w-50' : 'sk-w-85'}`} />
      ))}
    </div>
  );
}

/** Attente d'une liste de travaux : logo, titre, jalons, barre d'avancement. */
export function SkeletonWorkList({ count = 3 }) {
  return (
    <div className="work-list" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div className="card" key={i}>
          <div className="row" style={{ gap: 12, alignItems: 'flex-start' }}>
            <div className="skeleton" style={{ width: 44, height: 44, borderRadius: 10, flex: 'none' }} />
            <div style={{ flex: 1 }}>
              <div className="skeleton sk-line sk-w-50" style={{ height: 16 }} />
              <div className="skeleton sk-line sk-w-70" />
            </div>
          </div>
          <div className="skeleton sk-line" style={{ marginTop: 18, height: 21 }} />
          <div className="skeleton sk-line" style={{ height: 7, marginTop: 14, marginBottom: 0 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonRows({ count = 4 }) {
  return (
    <div className="card" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div className="skeleton sk-line" key={i} style={{ height: 18 }} />
      ))}
    </div>
  );
}

export default SkeletonCard;
